// index.js
import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './App';
import store from './store';
import SplashScreen from './components/layout/SplashScreen';
import "./App.css";

const root = ReactDOM.createRoot(document.getElementById('root'));

const Index = () => {
  const [isAppReady, setIsAppReady] = useState(false);
  const [transitionClass, setTransitionClass] = useState('opacity-0'); 
  const [deferredPrompt, setDeferredPrompt] = useState(null);


  useEffect(() => {
    const timer = setTimeout(() => {
      setIsAppReady(true); 
      setTimeout(() => {
        setTransitionClass('opacity-100'); 
      }, 50); 
    }, 3000); 

    return () => clearTimeout(timer);
  }, []);

  // useEffect(() => {
  //   const handleBeforeInstallPrompt = (event) => {
  //     event.preventDefault();
  //     setDeferredPrompt(event); // Save the event for triggering later
  //   };

  //   window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);

  //   return () => {
  //     window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
  //   };
  // }, []);

  // const handleInstall = () => {
  //   if (deferredPrompt) {
  //     deferredPrompt.prompt();
  //     deferredPrompt.userChoice.then((choiceResult) => {
  //       if (choiceResult.outcome === "accepted") {
  //         console.log("User accepted the install prompt");
  //       } else {
  //         console.log("User dismissed the install prompt");
  //       }
  //       setDeferredPrompt(null);
  //     });
  //   }
  // }

  return (
    <Provider store={store}>
      {!isAppReady && <SplashScreen />}
      {isAppReady && (
        <div className={`app-container ${transitionClass}`}>
          <App />
        </div>
      )}
    </Provider>
  );
};
// if ("serviceWorker" in navigator) {
//   navigator.serviceWorker
//     .register("/serviceworker.js", { scope: "/" })
//     .then((registration) => {
//       console.log("Service Worker registered with scope:", registration.scope);
//     })
//     .catch((error) => {
//       console.error("Service Worker registration failed:", error);
//     });
// }
root.render(<Index />);
